import SubmenuTabItem from './SubmenuTabItem';
import { SubmenuTabItemProps, SubmenuTabItemValueProps } from './types';

export type { SubmenuTabItemProps, SubmenuTabItemValueProps };
export default SubmenuTabItem;
